define('services/events/nutrition-events',[
    // libs
    'underscore', 'utils',
    // parent
    'src/event-aggregator'
], function(_, U, EventAggregator) {

    var NutritionEvents = _.extend({}, EventAggregator.prototype, {
        addFood: function(foods) {
            this.trigger('food:add', foods);
        },

        addRecipeFood: function(foods) {
            this.trigger('recipeFood:add', foods);
        },

        closeRecipe: function() {
            this.trigger('close:recipe');
        },

        toggleAll: function(value) {
            this.trigger('food:toggleAll', value);
        },

        defineClientCalorieGoalTarget: function(clientModel) {
            this.trigger('food:calorieGoalTarget', clientModel);
        },

        refreshPanel: function(){
            this.trigger('refreshPanel');
        },

        showFavorites: function() {
            this.trigger('showFavorites');
        },

        markAllAsConsumed: function() {
            this.trigger('markAllAsConsumed');
        },

        markAllAsNotConsumed: function() {
            this.trigger('markAllAsNotConsumed');
        }
    });

    return NutritionEvents;
});

